import { ROLES } from '@/constants';

// Roles allowed to open the HR document settings drawer (doc/email toggles +
// custom templates). eInvoiceOfficer reaches company edit but has no business
// with HR document generation, so the button is hidden for them.
export const DOCS_SETTINGS_ROLES = [
  ROLES.techAdmin,
  ROLES.superAdmin,
  ROLES.admin,
  ROLES.client,
  ROLES.clientOfficer,
];
